export default "__VITE_ASSET__BM$PpNFK__"